module.exports = __webpack_public_path__ + "static/media/google.25c6db79.png";